const T_PREFIX = "blog-card";

export const blogCardTrns = {
  readingTime: `${T_PREFIX}.reading-time`,
};
